import TagSelect from './tag-select';
import './styles/index.scss';
export default TagSelect;
